goog.provide('el8.appchart.visitNote.vitalsProcessor');
goog.require('el8.util.string');
goog.require('el8.uiwidget.alert');
goog.require('el8.service.urls');

/**
 * Cleans vital inputs which can handle multiple units and computes BMI
 */
el8.appchart.visitNote.vitalsProcessor = function(spec) {
    this._note = spec.note;
    this._form = spec.form;
    this._weightProcessedElt = spec.weightProcessedElt;
    this._heightProcessedElt = spec.heightProcessedElt;
    this._lastComputeBmi = {'weight': null, 'height': null};
    this._computeBMICallbackFn = spec.computeBMICallbackFn;
    this._bmiContainer = spec.bmiContainer;
    this._previousHeight = null;
    this._previousCustomObservations = null;
    this._isBmiDirty = false;
};

el8.appchart.visitNote.vitalsProcessor.prototype.reset = function() {
    this._lastComputeBmi = {'weight': null, 'height': null};
    this._previousHeight = null;
};

el8.appchart.visitNote.vitalsProcessor.prototype.setPreviousHeight = function(val) {
    this._previousHeight = val || null;
};
el8.appchart.visitNote.vitalsProcessor.prototype.setPreviousCustomObservations = function(val) {
    // Caches a value fetched by AJAX for later use when saving custom vitals
    // (i.e., "custom observations", they had a name change partway through development)
    this._previousCustomObservations = val || null;
};
el8.appchart.visitNote.vitalsProcessor.prototype.getPreviousCustomObservations = function() {
    return this._previousCustomObservations;
};

el8.appchart.visitNote.vitalsProcessor.prototype.processWeightInput = function() {
    var weightField = this._form.getInfoField('weight');
    if (weightField.getVal()) {
        var processedWeightDict = el8.util.string.cleanWeight(weightField.getVal());
        var cleanWeight = processedWeightDict.valueLbs;
        if (cleanWeight) {
            weightField.setVal(cleanWeight);
            this._weightProcessedElt.text(cleanWeight);
            this.computeBMI();
        }
        else {
            el8.uiwidget.alert('Please enter a valid weight.');
        }
    } else {
        this._weightProcessedElt.text('');
        this.computeBMI();
    }
    return weightField.getVal();
};

el8.appchart.visitNote.vitalsProcessor.prototype.processHeightInput = function(noBMI) {
    var heightField = this._form.getInfoField('height');
    if (heightField.getVal()) {
        var cleanHeight = el8.util.string.cleanLength(heightField.getVal());
        if (cleanHeight) {
            heightField.setVal(cleanHeight);
            this._heightProcessedElt.text(cleanHeight);
            if (!noBMI) { this.computeBMI(); }
        }
        else {
            el8.uiwidget.alert('Please enter a valid height.');
        }
    } else {
        this._heightProcessedElt.text('');
        if (!noBMI) { this.computeBMI(); }
    }
    return heightField.getVal();
};

el8.appchart.visitNote.vitalsProcessor.prototype.processHcInput = function() {
    var hcField = this._form.getInfoField('hc');
    if (hcField.getVal()) {
        var cleanCircumference = el8.util.string.cleanCircumference(hcField.getVal());
        if (cleanCircumference) {
            hcField.setVal(cleanCircumference);
        }
        else {
            el8.uiwidget.alert('Please enter a valid head circumference.');
        }
    }
    return hcField.getVal();
};

el8.appchart.visitNote.vitalsProcessor.prototype.processPainScaleInput = function() {
    var painScaleField = this._form.getInfoField('pain');
    var painScaleString = painScaleField.getVal();
    if (painScaleString) {
        var painScaleValue = Number(painScaleString);
        if (isNaN(painScaleValue) || !Number.isInteger(painScaleValue) 
            || painScaleValue < 0 || painScaleValue > 10) {
            el8.uiwidget.alert('Please enter a valid pain scale.');
        }
        else {
            painScaleField.setVal(String(painScaleValue));
        }
    }
    return painScaleString;
};

el8.appchart.visitNote.vitalsProcessor.prototype.computeBMI = function() {
    var height = this._heightProcessedElt.text();
    var weight = this._weightProcessedElt.text();
    var currPt = el8.ptdata.currPatient;
    if (!height && currPt && currPt.getAge() >= el8.util.consts.PEDIATRIC_AGE_LIMIT) {
        // Convenience: if there's no height in this visit, we'll calculate a BMI based
        // on the height in the last visit. But this only makes sense if we assume height
        // is pretty constant, which is a terrible assumption for children.
        // So we won't apply this for pediatric patients.
        height = this._previousHeight;
    }
    var that = this;
    if (weight && height) {
        if (this._lastComputeBmi['weight'] === weight &&
                this._lastComputeBmi['height'] === height) {
            // Don't compute again unnecessarily
            return;
        } else {
            this._lastComputeBmi['weight'] = weight;
            this._lastComputeBmi['height'] = height;
        }
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('computeBMI'),
            data: {'weight': weight, 'height': height},
            success: function(data) {
                var bmi = data['bmi'];
                that.setBMI(bmi || '');
                if (that._computeBMICallbackFn) { that._computeBMICallbackFn(data); }
            }
        });
    } else if (!weight) {
        this._lastComputeBmi['weight'] = '';
        that.setBMI('');
    } else if (!height) {
        this._lastComputeBmi['height'] = '';
        that.setBMI('');
    }
};

el8.appchart.visitNote.vitalsProcessor.prototype.setBMI = function(newVal) {
    // without the .trim(), an empty BMI produces an oldVal of " "
    var oldVal = this._bmiContainer.text().trim();
    if (oldVal !== newVal) {
        this._bmiContainer.text(newVal);
        this.setIsBMIDirty(true);
        if (this._note) { this.saveBMI(); } // only need to separately save BMI for notes (not Doc Vitals)
    }
};

el8.appchart.visitNote.vitalsProcessor.prototype.getIsBMIDirty = function() {
    return this._isBmiDirty;
};

el8.appchart.visitNote.vitalsProcessor.prototype.setIsBMIDirty = function(value) {
    return this._isBmiDirty = value;
};

el8.appchart.visitNote.vitalsProcessor.prototype.saveBMI = function() {
    if (!this._note) { return; }
    var that = this;
    var bmiVal = this._bmiContainer.text().trim();
    $.el8_ajax({
        type: 'POST',
        async: false,
        url: el8.service.urls.get('saveBmi', [this._note.getIdForUrl()]),
        data: JSON.stringify({'bmi': bmiVal, 'previous_value': this._note.getPreviousBmi()}),
        success: function(data) {
            that.setIsBMIDirty(false);
            if (data.bmi_delta) {
                that._note.setBmiDelta(data.bmi_delta);
            }
        },
        error_override: function() {} // expect last ditch save to save
    });
};
